export default __webpack_public_path__ + "static/program-revenue-932c8606d7d622c7bf824f03701879f6.png";